import {create} from "@targoninc/jess";
import {searchModalOpen, mobileMenuOpen, currentPage} from "../lib/state.ts";

export function navbar() {
    const isMac = (navigator as any).platform?.toUpperCase().indexOf("MAC") >= 0;
    const shortcutText = isMac ? "⌘ K" : "Ctrl K";

    return create("div")
        .classes("navbar", "flex", "align-children", "space-between")
        .children(
            create("div")
                .classes("flex", "align-children", "gap-h")
                .children(
                    create("button")
                        .classes("mobile-menu-toggle")
                        .text("☰")
                        .onclick(() => {
                            mobileMenuOpen.value = !mobileMenuOpen.value;
                        })
                        .build(),
                    create("div")
                        .classes("navbar-icon")
                        .onclick(() => {
                            currentPage.value = "index.md";
                            mobileMenuOpen.value = false;
                        })
                        .build(),
                    create("h3")
                        .classes("clickable")
                        .text("Jess Docs")
                        .onclick(() => {
                            currentPage.value = "index.md";
                            mobileMenuOpen.value = false;
                        })
                        .build()
                ).build(),
            create("div")
                .classes("search-container", "flex", "align-children")
                .onclick(() => {
                    searchModalOpen.value = true;
                })
                .children(
                    create("span")
                        .classes("material-symbols-outlined", "search-icon")
                        .text("search")
                        .build(),
                    create("span")
                        .classes("search-placeholder")
                        .text("Search...")
                        .build(),
                    create("span")
                        .classes("search-shortcut")
                        .text(shortcutText)
                        .build()
                ).build()
        ).build();
}